import { apiClient } from './apiClient';
import type {
  CreateDemoAccountRequest,
  CreateDemoAccountResponse,
  DemoAccountsResponse,
} from '../types/demoAccount';

export class DemoAccountService {
  static async createDemoAccount(
    payload: CreateDemoAccountRequest
  ): Promise<CreateDemoAccountResponse> {
    try {
      const response = await apiClient.post<CreateDemoAccountResponse>(
        '/admin/demo-accounts',
        payload
      );
      return response;
    } catch (error) {
      console.error('Failed to create demo account:', error);
      throw error;
    }
  }

  static async getDemoAccounts(): Promise<DemoAccountsResponse> {
    const response = await apiClient.get<DemoAccountsResponse>('/admin/demo-accounts');
    return response || { demoAccounts: [], total: 0 };
  }

  static async deleteDemoAccount(id: string): Promise<{ message: string }> {
    try {
      const response = await apiClient.delete<{ message: string }>(`/admin/demo-accounts/${id}`);
      return response;
    } catch (error) {
      console.error('Failed to delete demo account:', error);
      throw error;
    }
  }

  static async extendDemoAccount(id: string, additionalDays: number): Promise<{ message: string }> {
    try {
      const response = await apiClient.put<{ message: string }>(
        `/admin/demo-accounts/${id}/extend`,
        { additionalDays }
      );
      return response;
    } catch (error) {
      console.error('Failed to extend demo account:', error);
      throw error;
    }
  }
}
